import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Video, Share2, Copy } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa6";
import { api, fileUrl } from "@/lib/api";

export default function Greetings() {
  const { videoId } = useParams();
  const [items, setItems] = useState(null);

  useEffect(() => { api.get("/videos").then((r) => setItems(r.data)); }, []);
  useEffect(() => {
    if (videoId) {
      const el = document.getElementById(`video-${videoId}`);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [videoId, items]);

  const linkFor = (id) => `${window.location.origin}/saluti/${id}`;
  const shareWhatsApp = (v) => {
    const text = `Guarda il saluto di Il Mago Tony! ${linkFor(v.id)}`;
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank");
  };
  const copyLink = async (v) => {
    try { await navigator.clipboard.writeText(linkFor(v.id)); toast.success("Link copiato!"); }
    catch { toast.error("Copia non riuscita."); }
  };

  if (!items) return <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-green-500" /></div>;

  return (
    <div className="space-y-6">
      <header>
        <h1 className="flex items-center gap-2 font-display text-3xl font-black uppercase leading-tight tracking-tight text-zinc-950 sm:text-4xl">
          <Video className="h-8 w-8 text-green-500" /> Fai salutare un tuo amico da Il Mago Tony
        </h1>
        <p className="text-sm font-semibold text-zinc-500">I video in cui Tony saluta i suoi tifosi, uno per uno.</p>
      </header>

      {items.length === 0 ? (
        <div data-testid="greetings-empty" className="rounded-3xl border-2 border-dashed border-slate-300 bg-white p-10 text-center text-zinc-500">
          Nessun video pubblicato al momento. Torna presto!
        </div>
      ) : (
        <div className="grid gap-5 md:grid-cols-2" data-testid="greetings-list">
          {items.map((v) => (
            <div key={v.id} id={`video-${v.id}`} data-testid={`greeting-card-${v.id}`}
              className={`overflow-hidden rounded-3xl border-2 bg-white shadow-[6px_6px_0_0_#09090b] ${videoId === v.id ? "border-green-500" : "border-zinc-950"}`}>
              <video src={fileUrl(v.video_path)} controls playsInline className="h-auto w-full bg-black" />
              <div className="p-4">
                {v.caption && <p className="mb-3 text-sm font-semibold text-zinc-800">{v.caption}</p>}
                <div className="flex gap-2">
                  <button data-testid={`greeting-whatsapp-${v.id}`} onClick={() => shareWhatsApp(v)}
                    className="flex flex-1 items-center justify-center gap-2 rounded-full bg-[#25D366] py-2.5 text-sm font-bold text-white hover:opacity-90">
                    <FaWhatsapp className="h-4 w-4" /> WhatsApp
                  </button>
                  <button data-testid={`greeting-copy-${v.id}`} onClick={() => copyLink(v)}
                    className="flex flex-1 items-center justify-center gap-2 rounded-full border-2 border-zinc-950 py-2.5 text-sm font-bold text-zinc-950 hover:bg-slate-100">
                    <Copy className="h-4 w-4" /> Copia link
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
